<div class="rightSidebar_title">
  <img src='../../../../../assets/svg/redesign/nodes.svg' class="right-sidebar-tab-icon" />Nodes
  <div class="search-block">
    <input class="searchBtn" placeholder="Search nodes..." type="text"
      [ngClass]="{ active: searchValue ? true : false }" [(ngModel)]="searchValue" />
    @if (searchValue) {
      <div class="cancel-btn" (click)="clearSearch()"></div>
    }
  </div>
</div>

@if (!searchValue) {
  <div class="example-headers-align nodes-list-conteiner">
    @if (!active) {
      <div class="nodes-list-block">
        <!--  Menu`s  -->
        @if ((currentFlowType$ | async) !== FlowType.ApiFlow) {
          <div class="node-category" (click)="showAssets($event, 'menu')">
            <img src='../../../../../assets/svg/redesign/user_facing.svg' class="right-sidebar-tab-icon" />
            User-Facing Nodes
            <span class="chevron-right"></span>
          </div>
        }
        <!--  action`s  -->
        <div class="node-category" (click)="showAssets($event, 'action')">
          <img src='../../../../../assets/svg/redesign/actions.svg' class="right-sidebar-tab-icon" />
          Action Nodes
          <span class="chevron-right"></span>
        </div>
        <!--  integration`s  -->
        <div class="node-category" (click)="showAssets($event, 'integration')">
          <img src='../../../../../assets/svg/redesign/integrations.svg' class="right-sidebar-tab-icon" />
          Dynamic API Nodes
          <span class="chevron-right"></span>
        </div>
        <!--  Chat hub  -->
        <div class="node-category" (click)="showAssets($event, 'chatHub')">
          <img src='../../../../../assets/svg/redesign/chathub.svg' class="right-sidebar-tab-icon" />
          Integrations Nodes
          <span class="chevron-right"></span>
        </div>
      </div>
    } @else {
      <div class="back-block">
        <div class="left-back-block" (click)="showAssets($event, '')">
          <div class="back-img-block">
            <img src='../../../../../assets/svg/redesign/back-arrow.svg' class="right-sidebar-tab-icon" />
          </div>
          Back
        </div>

        <div class="img-block">
          <mat-select class="node-type-select" (selectionChange)="sortByChange($event.value)">
            <mat-option [value]="'type'">Node Type</mat-option>
            <mat-option [value]="'most_used'">Most Used</mat-option>
            <mat-option [value]="'alphabetical'">Alphabetical</mat-option>
          </mat-select>
        </div>
      </div>

      <div class="menu-nodes-block">
        @switch (active) {
          @case ('menu') {
            @if (sortNodesBy === 'type') {
              <p class="sorted-desc">
                Sorted By: <b>{{ sortedByTitles[sortNodesBy] }}</b>
              </p>
              @for (type of menuNodesTypes; track type.key) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>{{ type.title }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <node-types [searchValue]="searchValue" [nodes]="menuNodeTypes | async" [type]="type">
                  </node-types>
                </mat-expansion-panel>
              }
            } @else {
              <ng-container *ngTemplateOutlet="nodes; context: { nodes: menuNodeTypes | async, sortBy: sortNodesBy}">
              </ng-container>
            }
          }
          @case ('action') {
            <ng-container *ngTemplateOutlet="nodes; context: { nodes: actionNodeTypes | async, sortBy: sortNodesBy}">
            </ng-container>
          }
          @case ('integration') {
            <ng-container *ngTemplateOutlet="nodes; context: { nodes: integrationsNodeTypes | async, sortBy: sortNodesBy}">
            </ng-container>
          }
          @case ('chatHub') {
            @if (chatHubNodeTypes | async; as data) {
              @if (!data.length) {
                <ng-container *ngTemplateOutlet="chatHubNotFound"></ng-container>
              } @else if (data[0]?.type === 'error') {
                <ng-container *ngTemplateOutlet="chatHubError"></ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="nodes; context: { nodes: data, sortBy: sortNodesBy}">
                </ng-container>
              }
            }
          }
        }
      </div>
    }
  </div>
} @else {
  <div class="search-nodes-container">

    <node-types #menuSearch
      [nodes]="menuNodeTypes | async" [searchValue]="searchValue" [title]="'User-Facing Nodes'">
    </node-types>

    <node-types #actionSearch [searchValue]="searchValue" [nodes]="actionNodeTypes | async"
      [title]="'Action Nodes'"></node-types>

    <node-types #integrationSearch [nodes]="integrationsNodeTypes | async"
      [searchValue]="searchValue" [title]="'Integrations'"></node-types>

    <node-types #chatHubSearch [searchValue]="searchValue" [nodes]="chatHubNodeTypes | async" [title]="'Chat Hub'"></node-types>

    @if (menuSearch.isEmpty && actionSearch.isEmpty && integrationSearch.isEmpty && chatHubSearch.isEmpty) {
      <div class="no-assets-block">
        <div class="no-assets-title">No Results</div>
        <div class="no-assets-desc">
          Your search "<b>{{ searchValue }}</b>" returned no results
        </div>
      </div>
    }

  </div>
}


<ng-template #nodes let-nodes="nodes" let-sortBy="sortBy">
  <p class="sorted-desc">
    Sorted By: <b>{{ sortedByTitles[sortBy] }}</b>
  </p>
  <div class="active-block">
    <node-types [searchValue]="searchValue" [nodes]="nodes"></node-types>
  </div>
</ng-template>

<ng-template #chatHubNotFound>
  <div class="chatHubNotFoundContainer">
    <div class="chatHub-error">
      <div class="chatHub-error-img">
        <img src='../../../../../assets/svg/redesign/chathub-not-found.svg' />
      </div>
      <div class="chatHub-error-text">
        <div> You have no integrations set up.</div>
        <div>Go to the Clickatell Portal to set up your integrations.</div>
      </div>
      <div class="chatHub-error-footer">
          <a class="errorLink" href="https://clickatell.gitbook.io/flow/" target="_blank"> Go to Clickatell Portal</a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #chatHubError>
  <div class="chatHubNotFoundContainer">
    <div class="chatHub-error">
      <div class="chatHub-error-img">
        <img src='../../../../../assets/svg/redesign/chathub-error.svg' />
      </div>
      <div class="chatHub-error-text">
        <div>Failed to fetch integrations.</div>
        <div>Please try again.</div>
      </div>
      <div class="chatHub-error-footer">
        <button class="chatHub-retry" (click)="reloadChatHubProviders()">Retry</button>
      </div>
    </div>
  </div>
</ng-template>
